import type { User } from '~/server/types';
import type { SearchResultItem } from '@modules/search';
import type { DirectoryProductVariantsProfessionalPricing } from '../type/directory-product';
import { getUserCategory } from '@modules/product/util/pricing';

type ProductPricing = Pick<
    DirectoryProductVariantsProfessionalPricing | SearchResultItem,
    'PricingDisplay' | 'MemberPricing' | 'TradePricing'
>;

const getProductPricing = <T extends ProductPricing>(
    product: T,
    user: User,
): T['PricingDisplay'] | T['MemberPricing'] | T['TradePricing'] | null => {
    const userCategory = getUserCategory(user);

    if (userCategory === 'Trade' && product?.TradePricing) {
        if (!product.PricingDisplay?.Amount) {
            return product.TradePricing;
        }

        if (product.TradePricing.Amount < product.PricingDisplay.Amount) {
            return product.TradePricing;
        }
    }

    if (
        (userCategory === 'Customer' || userCategory === 'Trade') &&
        product?.MemberPricing
    ) {
        return product.MemberPricing;
    }

    return product?.PricingDisplay ?? null;
};

export { getProductPricing };
